import { createContext } from 'react';

export const SpartanProductHeroBannerEntranceContext =
  createContext<boolean>(true);
